import * as React from 'react'

import { Text } from '~ui/components/typography/Text/Text'

type TTextProps = Pick<PropsOf<typeof Text>, 'fontSize' | 'fontStyle' | 'contrast'>

export const TEXT_PROPS: TTextProps = {
  contrast: `low`,
  fontSize: `s14`,
  fontStyle: `regular`,
}

type TProps = RequiredChildren

/**
 * Formatted text for the footer section.
 */
export const FooterSectionText: React.FC<TProps> = ({ children }) => {
  return <Text {...TEXT_PROPS}>{children}</Text>
}
